import { useGetOrg } from "@src/api/organizations/get-organization";

const NEW_ORG_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

// Single source of truth for whether the Get Started onboarding feature is
// exposed. Gates the nav link, the route, the first-launch redirect, and the
// onboarding hand-off. Only orgs created within the last 30 days qualify —
// createdAtTs survives reinstalls, so a returning merchant past that window
// never sees onboarding.
export const useGetStartedEnabled = (): boolean => {
  const org = useGetOrg();

  return Date.now() - org.data.org.createdAtTs < NEW_ORG_MAX_AGE_MS;
};
